<template>
  <div class="slideDom" :style="{width: width,height: slideHeight,transform: 'translate3d('+offsetX+','+offsetY+',0)'}">
    <slot></slot>
  </div>
</template>
<script>
  import enums from '@/enums/index.js'

  export default {
    name: 'slide',
    data(){
      return {
        lastOffset: {
          top: 0,
          left: 0
        },
        startOffset: {
          top: 0,
          left: 0
        },
        wrapWidth: 0,
        wrapHeight: 0,
        slideHeight: '',
        offsetX: 0,
        offsetY: 0
      }
    },
    props: {
      width: {
        type: [String, Number],
        default: ''
      },
      height: {
        type: [String, Number],
        default: ''
      },
      direction: {
        type: Object,
        default(){
          return {X: true, Y: false}
        }
      }
    },
    watch: {
      width: function (val) {
        this.slideCreate();
      },
      maxTranslateLeft(val){
        this.$store.commit('changeGestureState', !!val);
      }
    },
    computed: {
      maxTranslateLeft(){
        let max = this.wrapWidth - (this.width + '').replace('px', '');
        max = max < 0 ? (max - 100) : 0;
        return max;
      },
      maxTranslateTop(){
        let max = this.wrapHeight - (this.slideHeight + '').toString().replace('px', '');
        max = max < 0 ? max - 20 : 0;
        return max;
      }
    },
    methods: {
      slideInit(){
        const events = enums.Events;
        this.$el.removeEventListener(events.touchStart, this.slideStart);
        document.body.removeEventListener(events.touchEnd, this.slideEnd);

        this.$el.addEventListener(events.touchStart, this.slideStart);
        document.body.addEventListener(events.touchEnd, this.slideEnd);
      },
      slideStart(e){
        e.preventDefault();
        const point = e.pageY ? e : event.touches[0];
        this.startOffset = {
          top: point.screenY,
          left: point.screenX
        }
        setTimeout(() => {
          this.$el.addEventListener(enums.Events.touchMove, this.slideing);
        })
      },
      slideing(e){
        e.preventDefault();
        this.$emit('slideing');
        let [allowX, allowY] = [this.direction.X, this.direction.Y];
        const classList = e.target.classList;
        if (classList.contains('swiper-slide')) {
          return;
        }
        const point = e.pageY ? e : event.touches[0];
        const currentOffset = {
          left: point.screenX,
          top: point.screenY
        }
        const startOffset = this.startOffset;
        const lastOffset = this.lastOffset;
        const offsetX = currentOffset.left - startOffset.left;
        const offsetY = currentOffset.top - startOffset.top;
        if (allowX) {
          lastOffset.left += offsetX;
          const lastOffsetLeft = lastOffset.left;
          if (this.maxTranslateLeft < 0) {
            if (lastOffsetLeft - this.maxTranslateLeft < 30) {
              this.$store.commit('changeGestureState', false);
            } else {
              this.$store.commit('changeGestureState', true);
            }
          }
          if (lastOffsetLeft < this.maxTranslateLeft) {
            lastOffset.left = this.maxTranslateLeft;
          } else if (lastOffsetLeft > 0) {
            lastOffset.left = 0;
          }
          this.offsetX = lastOffset.left + 'px';
          startOffset.left = currentOffset.left;
        }
        if (allowY) {
          const maxTranslateTop = this.maxTranslateTop;
          lastOffset.top += offsetY;
          const lastOffsetTop = lastOffset.top;
          if (lastOffsetTop < maxTranslateTop) {
            lastOffset.top = maxTranslateTop;
          } else if (lastOffsetTop > 0) {
            lastOffset.top = 0;
          }
          this.offsetY = lastOffset.top + 'px';
          startOffset.top = currentOffset.top;
        }
      },
      slideEnd(e){
        e.preventDefault();
        this.$el.removeEventListener(enums.Events.touchMove, this.slideing);
      },
      slideCreate(){
        this.wrapWidth = getComputedStyle(this.$el.parentNode).width.slice(0, -2);
        this.wrapHeight = getComputedStyle(this.$el.parentNode).height.slice(0, -2);
      }
    },
    created(){
      this.$store.commit('changeGestureState', false);
    },
    mounted(){
      this.slideCreate();
      this.slideInit();
      const that = this;
      if (this.direction.Y && this.height == '') {
        this.slideHeight = this.$el.scrollHeight
      } else if (this.height != '') {
        this.slideHeight = this.height;
      }
      window.onresize = function () {
        that.wrapWidth = getComputedStyle(that.$el.parentNode).width.slice(0, -2);
      }
    }
  }
</script>
<style lang="less" scoped>
  .slideDom {
    /* position: absolute; */
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    /* margin: auto; */
    transform: translate3d(0, 0, 0);
  }
</style>

<!-- <template>
  <div class="slideDom" :style="{width: width,height: slideHeight,transform: 'translate3d('+offsetX+','+offsetY+',0)'}" >
    <slot></slot>
  </div>
</template>
<script>
  import enums from '@/enums/index.js'
  export default {
    name: 'slide',
    data(){
      return {
        lastOffset: {
          top: 0,
          left: 0
        },
        startOffset: {
          top: 0,
          left: 0
        },
        wrapWidth: 0,
        wrapHeight: 0,
        slideHeight: '',
        offsetX: 0,
        offsetY: 0
      }
    },
    props: {
      width: {
        type: [String, Number],
        default: ''
      },
      height: {
        type: [String, Number],
        default: ''
      },
      direction: {
        type: Object,
        default(){
          return {X: true, Y: false}
        }
      }
    },
    watch: {
      width: function(val){
        this.slideCreate();
      },
      maxTranslateLeft(val){
        this.$store.commit('changeGestureState', !!val);
      }
    },
    computed: {
      maxTranslateLeft(){
        let max = this.wrapWidth - (this.width + '').replace('px', '');
        max = max < 0 ? (max - 100) : 0;
        return max;
      },
      maxTranslateTop(){
        let max = this.wrapHeight - (this.slideHeight + '').toString().replace('px', '');
        max = max < 0 ? max - 20 : 0;
        return max;
      }
    },
    methods: {
      slideInit(){
        const events = enums.Events;
        this.$el.removeEventListener(events.touchStart, this.slideStart);
        this.$el.parentNode.removeEventListener(events.touchEnd, this.slideEnd);

        this.$el.addEventListener(events.touchStart, this.slideStart);
        this.$el.parentNode.addEventListener(events.touchEnd, this.slideEnd);
      },
      slideStart(e){
        e.preventDefault();
        const point = e.pageY ? e : event.touches[0];
        this.startOffset = {
          left: point.pageX,
          top: point.pageY
        }
        console.log('start', point)
        setTimeout(() => {
          this.$el.addEventListener(enums.Events.touchMove, this.slideing);
        })
      },
      slideing(e){
        e.preventDefault();
        let [allowX, allowY] = [this.direction.X, this.direction.Y];
        const classList = e.target.classList;
        if(classList.contains('swiper-slide')){
          return;
        }
        const point = e.pageY ? e : event.touches[0];
        const currentOffset = {
          left: point.pageX,
          top: point.pageY
        }
        const startOffset = this.startOffset;
        const lastOffset = this.lastOffset;
        const offsetX = currentOffset.left - startOffset.left;
        const offsetY = currentOffset.top - startOffset.top;
        const offset = {
          left: lastOffset.left + offsetX,
          top: lastOffset.top + offsetY
        };
        if(allowX){
          const lastOffsetLeft = offset.left;
          if(this.maxTranslateLeft < 0){
            if(lastOffsetLeft - this.maxTranslateLeft < 30){
              this.$store.commit('changeGestureState', false);
            }else{
              this.$store.commit('changeGestureState', true);
            }
          }
          if(lastOffsetLeft < this.maxTranslateLeft){
            offset.left = this.maxTranslateLeft;
          }else if(lastOffsetLeft > 0){
            offset.left = 0;
          }
          this.offsetX = offset.left + 'px';
        }
        if(allowY){
          const maxTranslateTop = this.maxTranslateTop;
          lastOffset.top = offsetY;
          const lastOffsetTop = lastOffset.top;
          if(lastOffsetTop < maxTranslateTop){
            lastOffset.top = maxTranslateTop;
          }else if(lastOffsetTop > 0){
            lastOffset.top = 0;
          }
          this.offsetY = lastOffset.top + 'px';
        }
        this.lastOffset = lastOffset;
      },
      slideEnd(e){
        e.preventDefault();
        const point = e.pageY ? e : event.touches[0];
        console.log('end', point)
        const startOffset = this.startOffset;
        const lastOffset = this.lastOffset;
        this.lastOffset = {
          left: lastOffset.left + point.pageX - startOffset.left,
          top: lastOffset.top + point.pageY - startOffset.top
        }
        this.$el.removeEventListener(enums.Events.touchMove, this.slideing);
      },
      slideCreate(){
        this.wrapWidth = getComputedStyle(this.$el.parentNode).width.slice(0, -2);
        this.wrapHeight = getComputedStyle(this.$el.parentNode).height.slice(0, -2);
        // this.width = this.$el.style.width.slice(0, -2);
      }
    },
    mounted(){
      this.slideCreate();
      this.slideInit();
      const that = this;
      if(this.direction.Y && this.height == ''){
        this.slideHeight = this.$el.scrollHeight
      }else if(this.height != ''){
        this.slideHeight = this.height;
      }
      window.onresize = function(){
        that.wrapWidth = getComputedStyle(that.$el.parentNode).width.slice(0, -2);
      }
    }
  }
</script>
<style lang="less" scoped>
  .slideDom{
    /* position: absolute; */
    height: 100%;
    left: 0;
    top: 0;
    right:0;
    bottom: 0;
    z-index: 0;
    /* margin: auto; */
    transform: translate3d(0,0,0);
  }
</style>
 -->



// WEBPACK FOOTER //
// slide.vue?557fbd56